module.exports = __webpack_public_path__ + "img/mysticnarwhal_288.da33d276.png";